import { Button, Modal, Row } from 'antd'
import RequisitionsImportForm from '../../../components/Corporate/Requisitions/RequisitionsImportForm'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import React, { Fragment } from 'react'

function RequisitionsImport(props) {
  const {
    requisition,
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    isUpdatable,
    isRemovable,
    onShow,
  } = props

  const isNew = modalType === 'new'

  return (
    <Fragment>
      <Modal
        visible={visible}
        title={'Import Requisitions Lines'}
        onCancel={onCancel}
        destroyOnClose={true}
        footer={
          <FooterButtons
            remove={remove}
            visible={isUpdatable || isNew}
            removing={removing}
            submit={submit}
            update={update}
            submitting={submitting}
            title={'Import Requisitions Lines'}
            isNew={isNew}
            isEdit={!isNew}
            isRemovable={isRemovable}
          />
        }
        width={'75%'}>
        <Row>
          <RequisitionsImportForm ref={formRef} {...props} />
        </Row>
      </Modal>
      <Button
        data-testid={'add'}
        type={'default'}
        size="small"
        icon={'plus'}
        style={{ marginLeft: 10 }}
        // disabled={!isUpdatable}
        onClick={onShow}>
        Import Lines
      </Button>
    </Fragment>
  )
}

export default RequisitionsImport
